// Inserire in assets/black-friday.js
(function() {
  const countdownDate = new Date("Nov 29, 2025 23:59:59").getTime();
  
  function updateCountdown() {
    const now = new Date().getTime();
    const distance = countdownDate - now;
    
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    document.getElementById("days").innerHTML = String(days).padStart(2, '0');
    document.getElementById("hours").innerHTML = String(hours).padStart(2, '0');
    document.getElementById("minutes").innerHTML = String(minutes).padStart(2, '0');
    document.getElementById("seconds").innerHTML = String(seconds).padStart(2, '0');
    
    if (distance < 0) {
      document.getElementById("countdown-timer").innerHTML = "<p class='expired'>OFFERTA SCADUTA</p>";
    }
  }
  
  setInterval(updateCountdown, 1000);
  updateCountdown();
})();